export const FEATURE_STATUSES = {
  AVAILABLE: { text: "Disponível", color: "success" },
  COMING_SOON: { text: "Em breve", color: "info" },
  BETA: { text: "Beta", color: "warning" },
  DEPRECATED: { text: "Descontinuado", color: "error" },
  MAINTENANCE: { text: "Manutenção", color: "orange" },
  INTERNAL_ONLY: { text: "Interno", color: "grey" },
};

export const statusItems = Object.entries(FEATURE_STATUSES).map(
  ([value, meta]) => ({
    value,
    text: meta.text,
    color: meta.color,
  })
);

export const defaultFeature = () => ({
  slug: "",
  title: "",
  subtitle: "",
  description: "",
  icon: "mdi-star",
  public: true,
  status: "AVAILABLE",
  ctaLabel: "",
  ctaUrl: "",
  path: [],
  screenshots: [],
  links: [],
  categories: [],
  mainBenefits: [],
  faq: [],
  audienceIds: [],
  audiences: [],
});

export const defaultFeatureAudience = () => ({
  name: "",
  icon: "mdi-account-group",
  description: "",
  active: true,
  sortOrder: 0,
});

export const formatPath = (path) => {
  if (!Array.isArray(path) || !path.length) return "";
  return path.join(" / ");
};
